export const enum WebpartDataType {
    UnreadMail,
    DailyEvent,
    MonthlyEvent
}